export default __webpack_public_path__ + "static/media/uniswap.a7c8badf.svg";